import React, { Component, useEffect, useState } from 'react';
import Navigation from '../../../components/SuperAdmin/Navigation/Navigation';
import { ProSidebarProvider } from 'react-pro-sidebar';
import SidePanel from '../../../components/SuperAdmin/SidePanel/SidePanel';
import styles from './Home.module.css';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import MasterData from '../../SuperAdmin/MasterData/MasterData';

import { Util } from '../../../config/Util';
import Overview from '../../SuperAdmin/Overview/Overview';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import Admin from '../AdminManagement/Admin';

const Home = () => {

  // componentDidMount() {
  //   console.log("SA Home component mounted");
  //   if (Util.loginStatus || true) {
  //     document.getElementById("username").innerHTML = "Welcome, " + Util.user;
  //     this.props.history.push("/org-admin/overview");
  //   } else {
  //     this.props.history.push("/login");
  //   }

  // }

  const history = useHistory();
  const [collapsed, setCollapsed] = useState(false); 

  useEffect(() => {
    console.log("SA Home component mounted");
    if (Util.loginStatus) {
      const usernameElement = document.getElementById("username");
      if (usernameElement) {
        usernameElement.innerHTML = "Welcome, " + Util.user;
      }
      history.push("/org-admin/overview");
    } else {
      history.push("/landing");
    }
  }, [history]);

  return (
    <React.Fragment>
      <div className={styles.admin_dashboard_wrapper}>
        <div className={styles.navbar_wrapper}>
          <header className=''>
            <Navigation />
          </header>
        </div>
        <div className={styles.home_content_wrapper}>
          <div className={`overflow-auto ${styles.side_bar_wrap}`}>
            <ProSidebarProvider>
              <SidePanel collapsed={collapsed} setCollapsed={setCollapsed} />
            </ProSidebarProvider>
          </div>

          <div className={`${styles.admin_content_section} ${collapsed ? styles.collapsed : styles.expanded}`}>
  
            <Switch>
              <Route path="/org-admin/overview" exact>
                <Overview />
              </Route>
              <Route path="/org-admin/project" exact>
                <MasterData type="project" />
              </Route>
              <Route path="/org-admin/level" exact>
                <MasterData type="level" />
              </Route>
              <Route path="/org-admin/department" exact>
                <MasterData type="department" />
              </Route>
              <Route path="/org-admin/admin" exact>
                <Admin />
              </Route>
  
              {/* <Route path="/org-admin/*" >
                            <Redirect to='/login'/>
                          </Route> */}
            </Switch>
  
  
          </div>
        </div>
      </div>

      {/* <div className='row footer-wrap'>
          <Footer/>
        </div> */}
    </React.Fragment>





  )
}

export default Home;